import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'

import { ORGANIZATION_ADMIN_WORKSPACE_ID } from '@flowx/designer/modules/workspaces/shared/commons.types'

import { OrganisationAdmin } from '../shared/workspaces'
import { WorkspacesAndPermissionsStore } from '../workspaces-and-permissions.store'

export const setOrganisationAdminWorkspaceGuard: CanActivateFn = (): boolean => {
  const workspacesAndPermissionsStore = inject(WorkspacesAndPermissionsStore)

  // Set organisation admin as selected workspace before navigation
  const selectedWorkspace = workspacesAndPermissionsStore.selectedWorkspace()
  if (selectedWorkspace?.id !== OrganisationAdmin.id) {
    workspacesAndPermissionsStore.changeSelectedWorkspaceId(ORGANIZATION_ADMIN_WORKSPACE_ID)
  }
  return true
}
